// Avatar source normaliser.
//
// ``user.picture`` has come in two shapes over the life of this app:
//
//   * Raw SVG markup — the Firebase-era code minted identicons client-side
//     and stored the ``<svg>…</svg>`` string in the profile.
//   * A URL — the current Django backend's ``services/avatars.py`` returns
//     a DiceBear ``https://api.dicebear.com/…/svg?seed=…`` link for every
//     new signup.
//
// The UI codebase inherited a pattern of wrapping the value as
// ``data:image/svg+xml;utf8,${encodeURIComponent(picture)}``. That's only
// correct for raw SVG markup; when ``picture`` is a URL the wrapper emits
// ``data:image/svg+xml;utf8,https%3A%2F%2F…`` which is a malformed data
// URI and renders as a broken image everywhere (avatars in the navbar,
// profile header, search results, writers grid, comments, messages).
//
// ``avatarSrc(value)`` normalises both shapes to a usable ``<img src>``:
//   * URL (``http://`` / ``https://`` / ``//`` / ``data:``) → pass-through.
//   * SVG markup (``<svg …``) → data URI wrap.
//   * Anything else (empty / null) → empty string so the ``<img>`` stays
//     inert rather than showing a 404 glyph.
export function avatarSrc(value) {
  if (!value || typeof value !== "string") return "";
  const trimmed = value.trim();
  if (!trimmed) return "";
  if (
    trimmed.startsWith("http://") ||
    trimmed.startsWith("https://") ||
    trimmed.startsWith("//") ||
    trimmed.startsWith("data:")
  ) {
    return trimmed;
  }
  if (trimmed.startsWith("<svg") || trimmed.startsWith("<?xml")) {
    return `data:image/svg+xml;utf8,${encodeURIComponent(trimmed)}`;
  }
  return "";
}
